export const SUSPICIOUS_LOGIN_EXTERNAL_EVENT_NAME = "obgSuspiciousLogin";

export const SUSPICIOUS_LOGIN_MESSAGE_CODES = {
	error: {
		requestPinFailed: "E_REQUEST_PIN_FAILED",
		unhandled: "E_UNHANDLED",
	},
	success: {
		requestPinSuccess: "M_REQUEST_PIN_SUCCESS",
	},
};
